var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mcard"},[_c('div',{staticClass:"panel-title"},[_c('v-card-title',{staticClass:"pb-1"},[_c('main-title',{attrs:{"title":_vm.companyName}})],1),_c('v-card-text',{staticClass:"stitle"},[_vm._v(" MORE 아이디 : "+_vm._s(_vm.companyCode)+" ")])],1),_c('div',{staticClass:"pa-4",staticStyle:{"height":"500px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }